import ecran from "../../../../../core/injectors/ecran.injector";

export default ecran({
    source: "mr2003",
    ecrans: ["00-2"],
    params: ["dnecleint", "?dticleint", "?ppacleint", "?vaedtitypvnt", "?prucleint", "?prscleint", "?cifcleint", "?unacleint", "?cptcleint", "?el1cleint", "?el2cleint", "?el3cleint"]
});

